import { render } from "./GCBM.vue?vue&type=template&id=f693edc2&scoped=true"
import script from "./GCBM.vue?vue&type=script&lang=js"
export * from "./GCBM.vue?vue&type=script&lang=js"

import "./GCBM.vue?vue&type=style&index=0&id=f693edc2&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/flint.ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f693edc2"]])

export default __exports__